<script setup>
import SubscriptionConfirmation from '@/components/subscription/SubscriptionConfirmation.vue'
</script>

<template>
  <subscription-confirmation />
</template>
